// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"1230ef83","291":"a173c853","399":"c9821b43","450":"b1341688","614":"c879e1de"}[chunkId] + ".chunk.css";
};